import { Controller } from "@hotwired/stimulus"
import { useTransition } from 'stimulus-use'

export default class extends Controller {
  static targets = ["menu", "icon", "altIcon", "title", "button"]
  static values = {
    open: String,
    close: String,
    hideTrigger: { type: Boolean, default: false },
    initiallyOpen: { type: Boolean, default: false }
  }

  connect() {
    if (this.hasMenuTarget) {
      useTransition(this, { element: this.menuTarget, transitioned: this.initiallyOpenValue })
    }
  }

  toggle() {
    const wasClosed = this.menuTarget.classList.contains("hidden")
    this.toggleTransition()

    if (this.hasAltIconTarget) {
      this.iconTarget.classList.toggle("hidden")
      this.altIconTarget.classList.toggle("hidden")
    } else if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("-rotate-180")
    }

    if (this.hasTitleTarget && this.hasIconTarget) {
      this.titleTarget.innerHTML = this.iconTarget.classList.contains("-rotate-180") ? this.closeValue : this.openValue
    }

    if (this.hideTriggerValue) {
      this.buttonTarget.classList.toggle("hidden")
    }

    if (wasClosed) {
      this.dispatch("opened")
    }
  }

  handleOpened(event) {
    if (event.target !== this.element) {
      this.close()
    }
  }

  open() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.toggle()
    }
  }

  close() {
    if (!this.menuTarget.classList.contains("hidden")) {
      this.toggle()
    }
  }
}
